// extracted by mini-css-extract-plugin
export default {"subTitle":"_3mHb-"};